//#region types
import { ReconciliationWidgetProps } from "models/propTypes/accountingPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import ReconciliationWidgetListView from "./reconciliationWidgetListView";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";

const ReconciliationWidget: React.FC<ReconciliationWidgetProps> = (props) => {
  if (!props.reconciliationDate) {
    return (
      <Grid item className={clsx(cssExports.reconciliationWidget, cssExports.text)} xs>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.NoReconciliationDate)}
      </Grid>
    );
  }

  return (
    <Grid container item className={cssExports.reconciliationWidget} xs gap={4}>
      <ReconciliationWidgetListView reconciliationDate={props.reconciliationDate} />
      <Grid item className={cssExports.text} marginLeft={2}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.ReconciledTo, undefined, {
          date: DateHelper.formatDateToNumericString(props.reconciliationDate),
        })}
      </Grid>
    </Grid>
  );
};

export default ReconciliationWidget;
